import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { auth, dbAccounts } from "../../../../backend/firebaseConfig";

export const IO_PAYMENT_FLAGS_COLLECTION = "IOPaymentFlags";
export const IO_PAYMENT_FLAG_STATUSES = [
  { id: "open", name: "Open" },
  { id: "in-review", name: "In review" },
  { id: "resolved", name: "Resolved" },
];

const API_URL = (process.env.REACT_APP_SNOWFLAKE_API_URL || "http://localhost:10001")
  .replace(/\/$/, "");

export const subscribeIOPaymentFlags = (onData, onError) =>
  onSnapshot(
    query(
      collection(dbAccounts, IO_PAYMENT_FLAGS_COLLECTION),
      orderBy("datapoints.lastSeenAt", "desc"),
    ),
    (snapshot) => onData(snapshot.docs.map((entry) => {
      const data = entry.data();
      return {
        id: entry.id,
        ...(data.datapoints || data),
      };
    })),
    onError,
  );

export const updateIOPaymentFlagStatus = async (flagId, status) => {
  const token = await auth.currentUser?.getIdToken(true);
  if (!token) throw new Error("Please sign in again.");
  const response = await fetch(
    `${API_URL}/api/payment-flags/${encodeURIComponent(flagId)}/status`,
    {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ status }),
    },
  );
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || "Unable to update the payment flag.");
  return body;
};
